import React from 'react';
import {Modal} from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import Boton from './Boton'

const VentanaModal = ({mensajeHeader, mensajeBody, estadoModal, setEstadoModal, handleConfirm}) => {
    const handleClose = () => setEstadoModal(false);

    return (
        <Modal show={estadoModal} onHide={handleClose} animation={true} >

            <Modal.Header closeButton>
                <p className='mb-0'>{mensajeHeader}</p>
            </Modal.Header>

            <Modal.Body>
                <p className='my-2'>{mensajeBody}</p>
            </Modal.Body>

            <Modal.Footer>
                <Boton onClick={handleClose}>Cancelar</Boton>
                <Boton onClick={handleConfirm} variant="primary" primario="true">Confirmar</Boton>
            </Modal.Footer>
        </Modal>
    );
}
 
export default VentanaModal;